import io from "socket.io-client";
import { base_URL } from "utils/base_url.js";
export const Socket = io(base_URL, {
  transports: ["websocket"],
});